import { createApp } from 'vue';
import { createPinia } from 'pinia';
import store from './vuex';
import piniaPersist from 'pinia-plugin-persist';
import App from './App.vue';
import router from './router';

import {
  Affix,
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Carousel,
  Cascader,
  Checkbox,
  ConfigProvider,
  Collapse,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Drawer,
  Empty,
  Form,
  InputNumber,
  Input,
  Layout,
  Menu,
  Modal,
  Popconfirm,
  Popover,
  Radio,
  Row,
  Select,
  Slider,
  Space,
  Spin,
  Statistic,
  Switch,
  Table,
  Tabs,
  Tag,
  TimePicker,
  TreeSelect,
  Tooltip,
  Upload,
} from 'ant-design-vue';
import * as antIcons from '@ant-design/icons-vue';
// 全局样式表
import './assets/global.less';

// app
const app = createApp(App);
// pinia
const pinia = createPinia();
pinia.use(piniaPersist);
// 插件
app.use(router);
app.use(pinia);
app.use(Affix);
app.use(Avatar);
app.use(Breadcrumb);
app.use(Button);
app.use(Card);
app.use(Carousel);
app.use(Cascader);
app.use(Checkbox);
app.use(ConfigProvider);
app.use(Collapse);
app.use(Col);
app.use(DatePicker);
app.use(Descriptions);
app.use(Divider);
app.use(Drawer);
app.use(Empty);
app.use(Form);
app.use(InputNumber);
app.use(Input);
app.use(Layout);
app.use(Menu);
app.use(Modal);
app.use(Popconfirm);
app.use(Popover);
app.use(Radio);
app.use(Row);
app.use(Select);
app.use(Slider);
app.use(Space);
app.use(Spin);
app.use(Statistic);
app.use(Switch);
app.use(Table);
app.use(Tabs);
app.use(Tag);
app.use(TimePicker);
app.use(TreeSelect);
app.use(Tooltip);
app.use(Upload);
// 注册icon
Object.keys(antIcons).forEach(key => {
  app.component(key, antIcons[key])
});
// 添加到全局
app.config.globalProperties.$antIcons = antIcons;

import { notification } from 'ant-design-vue';
let $message = {
  success: (message) => notification.success({ description: message }),
  error: (message) => notification.error({ description: message }),
  warning: (message) => notification.warn({ description: message }),
  info: (message) => notification.info({ description: message }),
};
app.config.globalProperties.$message = $message;
app.config.globalProperties.$modal = Modal;
app.config.globalProperties.$filterOptions = (input, option) => (option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0);
// vuex store
app.use(store);

app.mount('#app');

// 通用方法
app.config.globalProperties.$getOptions = (opt) => {
  return {
    label: opt.val,
    value: opt.key
  };
};
app.config.globalProperties.$onRoute = (name, params) => {
  router.push({ name, params });
};

// 图片浏览
import gallery from 'img-vuer3';
import 'img-vuer3/dist/style.css';
app.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
  sliderBackgroundColor: 'rgba(0,0,0,0.6)',
  sliderZIndex: 1001,
});

export default app;